import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartOrderTypeId = createSelector(cartState, (cart) => cart.orderTypeId ?? null);
